import * as classnames from 'classnames/bind'
import * as React from 'react'
import styles from './nav.scss'

const cx = classnames.bind(styles)
class NavContainer extends React.Component<React.HTMLProps<HTMLUListElement>> {
  public render() {
    const { children, className } = this.props
    return (
      <ul {...this.props} className={cx('nav', className)}>{children}</ul>
    )
  }
}

export default NavContainer



// WEBPACK FOOTER //
// ./src/components/Nav/container.tsx